import { useEffect, useMemo, useState } from "react";
import { Background, Button, Checked, Container, CustomInput, Headline, InfoLi, Input, InputContainer, Label, PackageContainer, Price, ProductCard, Subtitle, TopContainerCard, TotalPrice, TotalText, UnorderedList, ProductCardContainer, ProductName, CardContainer, CardContainerLeft, TotalPriceContainer, SalaryinsuranceInfoLabel, Arrow, LeadSuccessInfo, PackageToast, CloseIcon, PackageToastTitle, PackageToastContent, PackageToastHeader, PackageToastLink, PackageToastCTA, PackageToastContentSmall, PackageToastContainer, StarIcon, OfferLabelToast, InlineToastLink, InlineToast } from "./SalaryInsuranceConfigCard.style";
import Analytics from "../../utils/analytics";
import SalaryInsuranceCalculator from "./Calculator/Calculator";
import OccupationPicker, { OccupationOption } from "./OccupationPicker/OccupationPicker";
import Leadpopup from "./Calculator/components/Leadpopup/Leadpopup";
import { Package } from "lucide-react";
import { OfferLabel } from "../FormEnrollmentNew/components/ProductCard/ProductCard.style";

export interface ProductFeature {
  FeatureDescription: string;
  FeatureTitle: string;
  Key: string;
}

export interface ProductConfig {
  ProductTitle: string;
  Price: string;
  Features: ProductFeature[];
  ProductTargetVariant: string;
  Key: string;
  ProductId: string;
  DefaultChoosen: boolean;
}


export default function SalaryInsuranceConfigCard() {
    const [productList, setProductList] = useState<ProductConfig[]>([]);
    const [unemploymentBenefitsChecked, setUnemploymentBenefitsChecked] = useState<boolean>(false);
    const [salaryInsuranceChecked, setSalaryInsuranceChecked] = useState<boolean>(false);
    const [headline, setHeadline] = useState<string>();
    const [subtitle, setSubtitle] = useState<string>();
    const [btnUrl, setBtnUrl] = useState<string>();
    const [btnText, setBtnText] = useState<string>();
    const [campaignSource, setCampaignSource] = useState<string>();
    const [showContactMe, setShowContactMe] = useState<boolean>(false);
    const [showCalculator, setShowCalculator] = useState<boolean>(false);
    const [isDesktop, setIsDesktop] = useState<boolean>(false);
    const [salaryInsuranceCheckPrice, setSalaryInsuranceCheckPrice] = useState<number>(0);
    const [totalMonthlyPayout, setTotalMonthlyPayout] = useState<string>("");
    const [grossSalary, setGrossSalary] = useState<string>("");
    const [period, setPeriod] = useState<string>("");
    const [coverageAmount, setCoverageAmount] = useState<string>("");
    const [leverandoer, setLeverandoer] = useState<string>("");
    const [showOccupationPicker, setShowOccupationPicker] = useState<boolean>(false);
    const [leadpopupHeadline, setLeadpopupHeadline] = useState<string>();
    const [leadpopupSubtitle, setLeadpopupSubtitle] = useState<string>();
    const [leadSent, setLeadSent] = useState<boolean>(false);
    const [showPackageToast, setShowPackageToast] = useState<boolean>(false);
    
    //Check for window size
    useEffect(() => {
    if(window.innerWidth > 750) {
        setIsDesktop(true)
        } else {
        setIsDesktop(false)
        }
    }, []);
    
    //Get data from umbraco backend
    useEffect(() => {
        const form = document.querySelector(`[data-component='salaryinsurance-config-card']`) as HTMLElement;
        const headline = form?.dataset.productconfigHeadline;
        const subtitle = form?.dataset.productconfigSubtitle;
        const products = form?.dataset.productconfigProducts;
        const btnUrl = form?.dataset.productconfigBtnUrl;
        const btnText = form?.dataset.productconfigBtnText;
        const campaignSource = form?.dataset.productconfigCampainsource;
        setHeadline(headline)
        setSubtitle(subtitle)
        setBtnUrl(btnUrl)
        setBtnText(btnText)
        setCampaignSource(campaignSource)
        if(products) {
            setProductList(JSON.parse(products) as ProductConfig[]);
        }
    }, [])
    
    //tracking
    const trackOpenCalculator = () => {
        Analytics.getInstance().trackSalaryInsuranceAction("presented", grossSalary, coverageAmount, period, salaryInsuranceCheckPrice.toString(), totalMonthlyPayout, "salaryinsurance_config")
    }

    const trackingCTAClick = () => {
        setTimeout(() => {
            Analytics.getInstance().trackSalaryInsuranceAction("go_to_checkout", grossSalary, coverageAmount, period, salaryInsuranceCheckPrice.toString(), totalMonthlyPayout, "salaryinsurance_config")
        }, 2000);
    }


    //Preselect products if they are set to "Default choosen" in Umbraco
    useEffect(() => {
        productList.map(product => {
            if(product.ProductTargetVariant === "akasse" && product.DefaultChoosen) {
                setUnemploymentBenefitsChecked(true);
            }
            if(product.ProductTargetVariant === "loensikring" && product.DefaultChoosen) {
                setSalaryInsuranceChecked(true);
            }
        })
        
    }, [productList])


    //Reset calculator fields to their default values
    const resetCalculator = () => {
        setPeriod("3")
        setSalaryInsuranceCheckPrice(0)
        setTotalMonthlyPayout("")
        setGrossSalary("")
        setCoverageAmount("2000")
    }

    //Click on productcard
    const clickEvent = (productTargetVariant: string) => {
        if(productTargetVariant === "akasse") {
            unemploymentBenefitsChecked ? setUnemploymentBenefitsChecked(false) : setUnemploymentBenefitsChecked(true)
        } 
        if(productTargetVariant === "loensikring" ) {
            if(salaryInsuranceChecked) {
                setSalaryInsuranceChecked(false)
                resetCalculator()
            } else {
                setSalaryInsuranceChecked(true)
                setShowCalculator(true)
                trackOpenCalculator();
            }
        }
        
    }

    const checkedInput = (productTargetVariant: string) => {
        if(productTargetVariant === "akasse") {
            return unemploymentBenefitsChecked
        } 
        if(productTargetVariant === "loensikring") {
            return salaryInsuranceChecked
        }
    }

    //Loop through products
    const ProductCardList = productList?.map(product => {
        return (
        <ProductCard 
            id={product.ProductId} 
            key={product.ProductId} 
            checked={checkedInput(product.ProductTargetVariant)}
            isSelfemployeedPackage={false}
        >
            <TopContainerCard onClick={() => clickEvent(product.ProductTargetVariant)}>
                <CardContainer>
                    <CardContainerLeft>
                        <div>
                            <Input  type="checkbox" id={`product`+`${product.ProductId}`} />
                            <CustomInput checked={checkedInput(product.ProductTargetVariant)}>
                            {checkedInput(product.ProductTargetVariant) && (
                                <Checked></Checked>
                            )}
                            </CustomInput>
                        </div>
                        <InputContainer>
                            <Label htmlFor={`product`+`${product.ProductId}`}>{product.ProductTitle}</Label>
                            <ProductName>{product.ProductTitle}</ProductName>
                            <UnorderedList>
                                {product.ProductTargetVariant === "loensikring" && coverageAmount !== "" && period !== "" && salaryInsuranceChecked ? (
                                    <InfoLi key="period">{coverageAmount} kr./md oveni dagpengene i {period} mdr.</InfoLi>
                                ) : (
                                    <>
                                    {(product.Features.map(i =>
                                        <InfoLi id={i.Key} key={i.Key}>{i.FeatureTitle}</InfoLi>
                                    ))}
                                    </>
                                )} 
                            </UnorderedList>
                        </InputContainer>
                    </CardContainerLeft>
                    <Price productTargetVariant={product.ProductTargetVariant} strikeThrough={false}>
                        {salaryInsuranceCheckPrice > 0 && product.ProductTargetVariant === "loensikring" ? (
                            <>
                                {salaryInsuranceCheckPrice} <span>kr./md.</span>
                            </>
                        ) : (
                            <>
                                {product.ProductTargetVariant === "loensikring" ? (
                                        <span>Fra {product.Price} kr./md.</span>
                                ) : (
                                    <>{product.Price} <span>kr./md.</span></>
                                )}
                            </>
                        )}
                    </Price>
                </CardContainer>
            </TopContainerCard>
            {product.ProductTargetVariant === "loensikring" && (
            <SalaryinsuranceInfoLabel onClick={() => {setShowCalculator(true), trackOpenCalculator(), setSalaryInsuranceChecked(true)}}>
                {salaryInsuranceChecked ? "Genberegn din lønsikring og pris" : "Beregn din lønsikring og pris"} 
                <Arrow />
            </SalaryinsuranceInfoLabel>
            )}
        </ProductCard>
        );
    });
    
    //calculate totalPrice
    const totalPrice = useMemo(() => {
        let unemploymentBenefitsPrice = 0
        let salaryInsurancePrice = 0

        productList?.map(product => {
            if(product.ProductTargetVariant === "akasse") {
                unemploymentBenefitsPrice = unemploymentBenefitsChecked ? Number(product.Price) : 0 
            } 
            if(product.ProductTargetVariant === "loensikring") {
               salaryInsurancePrice = salaryInsuranceChecked ? Number(salaryInsuranceCheckPrice) : 0
            }
        })

        return unemploymentBenefitsPrice + salaryInsurancePrice

    }, [productList, unemploymentBenefitsChecked, salaryInsuranceChecked, salaryInsuranceCheckPrice])

    //Choosen product added to url 
    const getChosenProductVariants = useMemo(() => {
        let chosen: string = "";
        productList.forEach(product => {
            if ((product.ProductTargetVariant === "akasse" && unemploymentBenefitsChecked) || (product.ProductTargetVariant === "loensikring" && salaryInsuranceChecked)) {
                if(chosen.length > 0) {
                    chosen += `|${product.ProductTargetVariant}`;
                } else {
                    chosen += product.ProductTargetVariant;
                }
            }
        });
        return chosen;
    }, [unemploymentBenefitsChecked, salaryInsuranceChecked]);

    const handleRedirect = (option: OccupationOption) => {
        if(option.occupation === "employee") {
            let url: string = `${btnUrl}?produkt=${getChosenProductVariants}&step=3&type=${option.occupation}`
            if(salaryInsuranceCheckPrice > 0) {
                url += `&salaryinsurance=${salaryInsuranceCheckPrice}&period=${period}&coverage=${coverageAmount}&grossSalary=${grossSalary}`
            }

            if(campaignSource != "" ) {
                url += `&campaign=${campaignSource}`
            }
            window.location.href = url;
        } else {
            getLeadPopupContent(option.occupation)
            setShowContactMe(true);
            setShowOccupationPicker(false);
        }
    }

    const handleCTAClick = () => {
        if(salaryInsuranceChecked && !unemploymentBenefitsChecked) {
            getLeadPopupContent("unemployed")
            setShowContactMe(true);
        } else {
            setShowOccupationPicker(true);
        }
    }

    //Lead pop
    const getLeadPopupContent = (occupation: string) => {
        if (occupation === "unemployed" || occupation === "student") {
            setLeadpopupHeadline("Vi har brug for at snakke med dig");
            setLeadpopupSubtitle("For at kunne give dig den bedste service, har vi brug for at snakke med dig. Udfyld venligst dine oplysninger, så ringer vi dig op hurtigst muligt.");
        } else {
            setLeadpopupHeadline("Næste skridt: Få din lønsikring på plads");
            setLeadpopupSubtitle("Vi ringer dig op og hjælper dig med at oprette din lønsikring korrekt.");
        }
    }

    const succesfullLeadSend = () => {
        setLeadpopupHeadline("Tak for din henvendelse");
        setLeadpopupSubtitle("Vi har modtaget dine oplysninger og vil kontakte dig snarest muligt.");
        setLeadSent(true);
    }

    const scrollToCard = () => {
        const cardElement = document.getElementById("salaryInsuranceConfigCardModule");
        cardElement?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
        <Background>
            <Container>
                {headline != "" && headline != undefined &&
                    <Headline>{headline}</Headline>
                }
                {subtitle != "" && subtitle != undefined &&
                    <Subtitle dangerouslySetInnerHTML={{__html: subtitle || ""}} />
                }
                <PackageContainer isPackage={false}>
                    <ProductCardContainer>
                        {ProductCardList}
                    </ProductCardContainer>
                    {showPackageToast && !isDesktop && (
                        <InlineToast>
                            <StarIcon src="/assets/images/recommend2.svg"/>
                            <div>
                                Vi har fundet et bedre match til dig. <br/>
                                <InlineToastLink href="https://www.ase.dk/kp/pakketilbud">Se anbefaling</InlineToastLink>
                            </div>
                        </InlineToast>
                    )}
                    <TotalPriceContainer>
                        <div>
                            <TotalText>
                                Samlet pris pr. måned
                            </TotalText>
                            <TotalPrice>{totalPrice} <span>kr./md.</span></TotalPrice>
                        </div>
                        <Button 
                            className="button" 
                            onClick={() => {trackingCTAClick(); handleCTAClick();}} 
                            active={(unemploymentBenefitsChecked || salaryInsuranceChecked) && !leadSent}
                        >
                            {btnText}
                        </Button>
                    </TotalPriceContainer>
                    {leadSent && (
                        <LeadSuccessInfo>*Vi har modtaget dine oplysninger</LeadSuccessInfo>
                    )}
                </PackageContainer>
                {showPackageToast && isDesktop && (
                    <>
                    <PackageToast>
                        <PackageToastHeader>
                            <PackageToastTitle>Vi har fundet et bedre match til dig</PackageToastTitle>
                            <CloseIcon onClick={() => setShowPackageToast(false)} />
                        </PackageToastHeader>
                        <PackageToastContainer>
                            <PackageToastContent>Få mere tryghed for pengene med a-kasse, fagforening inkl. lønsikring.</PackageToastContent>
                            <PackageToastCTA className="button" onClick={() => { window.location.href = "https://www.ase.dk/kp/pakketilbud"; }}>Se anbefaling</PackageToastCTA> 
                        </PackageToastContainer>
                    </PackageToast>
                    </>
                )}
            </Container>
        </Background>
        <SalaryInsuranceCalculator 
            isOpen={showCalculator}
            onBelowThreshold={() => {setShowCalculator(false); scrollToCard(); setUnemploymentBenefitsChecked(true); setSalaryInsuranceChecked(false);}} 
            onClose={() => {setShowCalculator(false); scrollToCard(); }} 
            onCalculate={(price, grossSalary, period, coverageAmount, totalMonthlyPayout, leverandoer) => { setSalaryInsuranceCheckPrice(price); setTotalMonthlyPayout(totalMonthlyPayout); setGrossSalary(grossSalary); setPeriod(period); setCoverageAmount(coverageAmount); setLeverandoer(leverandoer); }} 
            onPackageMatch={() => setShowPackageToast(true)}
        />
        {showOccupationPicker && (
            <OccupationPicker
                title="Vælg din beskæftigelse"
                subtitle="Dette hjælper os med at tilpasse dine muligheder"
                onClose={() => {setShowOccupationPicker(false); scrollToCard();}}
                onOptionSelect={(option) => handleRedirect(option)}
                options={[{ title: "Lønmodtager - i job", occupation: "employee" }, { title: "Lønmodtager - ledig", occupation: "unemployed" }, { title: "Studerende", occupation: "student" }, { title: "Selvstændig", occupation: "selfemployed" }]}
            />
        )}
        {showContactMe && (
            <Leadpopup 
                headline={leadpopupHeadline}
                subtitle={leadpopupSubtitle}
                salary={grossSalary} 
                period={period} 
                amount={coverageAmount} 
                fullAmount={totalMonthlyPayout} 
                price={salaryInsuranceCheckPrice.toLocaleString('da-DK')} 
                leverandoer={leverandoer} 
                onClose={() => {setShowContactMe(false); scrollToCard();}} 
                onSuccess={() => { setShowOccupationPicker(false); succesfullLeadSend();}} 
                wantsSalaryInsurance={salaryInsuranceChecked}
            />
        )}
    </>
    )

}